import { clsx } from "clsx";
import classes from "./Spinner.module.scss";
import { SpinnerProps } from "./SpinnerProps";

export function Spinner(props: SpinnerProps) {
  const {
    className,
    size = 32,
    color = "currentColor",
    message = "Loading...",
  } = props;

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={message}
      className={clsx(classes.wrapper, className)}
    >
      <svg
        className={classes.spinner}
        width={size}
        height={size}
        viewBox="0 0 66 66"
        data-testid="spinner"
      >
        <circle
          className={classes.path}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
    </span>
  );
}
